import { ConfigSlots } from "./configCommands";

// Default starting slots copied from Unreal's "Presets/Default 21C/ConfigSave.json".
// These give the React menu the same initial selected state before browser saves exist.
export const defaultConfigSlots: ConfigSlots = {
  Example: "Exterior",
  PaintMain: "DATA_Ghostrider_satin",
  PaintBadge: "DATA_Jester_Gloss",
  PaintStripe: "DATA_Hercules_Satin",
  PinStripe: "DATA_ElMirage_gloss",
  PaintWing: "DATA_ElMirage_gloss",
  Trim: "Data_Alcantara_Mango",
  Stitch: "Data_Stitch_CZWhite",
  Alloy: "DATA_Alloy_SatinBlack",
  MetalTrim: "Data_MetalTrim_Galactic",
  Seatbelt: "Data_Seatbelt_Black",
  Pedals: "Data_Exhaust_CobaltBlack",
  Caliper: "Data_Caliper_PirateBay",
  CaliperLogo: "Data_Caliper_IceMan",
  IntCarbonPeri: "Data_Carbon_IntSatin",
  IntCarbonBespoke: "DATA_PointReturn_carbon",
  SWheelA: "Data_Alcantara_Mango",
  Gyroids: "Data_Exhaust_CobaltBlack",
  AccPaint: "DATA_Hercules_satin",
  AccPaint2: "DATA_Hercules_satin",
  IntCarbonSeat: "DATA_ExtCarbon_Gloss",
  IntCarbonBSeat: "DATA_ExtCarbon_Gloss",
  Carbon: "DATA_ExtCarbon_Satin",
  Paint12OClock: "DATA_ElMirage_gloss",
  "Variant Model": "21C",
  "Variant 21C_Stripes_UTILITY": "Unset",
  "Variant 21c_V_Max_Stripes_UTILITY": "Unset",
  "Variant Wheel": "Premiere",
  "Variant Wheel_Cover": "off",
  "Variant Int_CNC_Stitch_Panels": "Standard",
  "Variant 21C_Livery_Full_Stripe_Kit": "Unset",
  "Variant Display Plinth": "No Plinth",
  "Variant 21C_Goldrush": "Unset",
  "Variant Location": "Euro",
  "Variant Stripes": "Lasso",
  "Variant CarbonFuselage": "Unset",
  "Variant CarbonMask": "Unset",
  "Variant CarbonSill": "On",
  "Variant StripeLasso": "Unset",
  "Variant WingStripe": "Unset",
  "Variant WingStripeEdge": "Unset",
  "Variant WheelCarbonHoop": "Off",
  "Variant DiffuserStripe": "Unset",
  "Variant WingEndCap": "End_CapOff",
  "Variant RearDiffuser_Pinstripe": "Off",
  "Variant RearDiffuser_PinstripeLow": "Off",
  "Variant Sill_Pinstripe": "Off",
  "Variant DivePlane_Pinstripe": "Off",
  "Variant FSplitter_Pinstripe": "Off",
  "Variant IntCarbonPeripherals": "Standard",
  "Variant IntCarbonPerSeat": "Standard",
  "Variant SWheelMaterial": "Alcantara",
  "Variant Gyroids": "Standard",
  "Variant 12Clock": "Standard",
  "Variant Pedals": "Standard",
  "Variant WheelNut": "Standard",
  "Variant Calipers": "Foundation",
  "Variant Badge": "Ablack",
  "Variant StripesThick": "Unset",
  "Variant Perforation": "No_Perf",
  "Variant MirrorStripe": "Off",
  "Variant AccentsWing": "Off",
  "Variant AccentsLowWing": "Off",
  "Variant AccentsWingMount": "Off",
  "Variant AccentsIntake": "Off",
  "Variant AccentsDivePlane": "Off",
  "Variant AccentsSplitter": "Off",
  "Variant AccentsSill": "Off",
  "Variant AccentsMirrorArms": "Off",
  "Variant AccentsMirrorCaps": "Deviate",
  "Variant CarbonPeriph": "Unset",
  "Variant CarbonPeriphFront": "Unset",
  "Variant CarbonPeriphDiff": "Off",
  "Variant CarbonPeriphDuct": "Off",
  "Variant Trim": "Textile",
  "Variant ExtCarbon": "Satin",
  "Variant SpyderRoof": "Unset",
  "Variant BodyType": "Unset",
  Perf_PerfColour: "(R=0.444000,G=0.073792,B=0.013320,A=1.000000)",
};
